import React from "react";

export default function VisaIcon() {
  return (
    <svg
      width="46"
      height="22"
      viewBox="0 0 46 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2409 14H13.7344L11.8548 8.40075C11.7656 8.14318 11.5762 7.91548 11.2975 7.80816C10.6022 7.53846 9.83591 7.32382 9 7.21557V7H13.0378C13.595 7 14.013 7.32382 14.0827 7.69991L15.0579 11.7388L17.5632 7H20L16.2409 14ZM21.1937 14H19L20.8063 7H23L21.1937 14ZM25.3974 9.03731C25.4654 8.67166 25.8734 8.46259 26.3494 8.46259C27.0973 8.41009 27.9121 8.51508 28.592 8.77574L29 7.31406C28.32 7.10499 27.5721 7 26.8933 7C24.6506 7 23.0187 7.94036 23.0187 9.24547C23.0187 10.2383 24.1747 10.7596 24.9906 11.0737C25.8734 11.3869 26.2134 11.5959 26.1454 11.9091C26.1454 12.3788 25.4654 12.5879 24.7866 12.5879C23.9707 12.5879 23.1547 12.4313 22.408 12.1697L22 13.6323C22.816 13.893 23.6987 13.998 24.5147 13.998C27.0293 14.0496 28.592 13.1101 28.592 11.7C28.592 9.92427 25.3974 9.82019 25.3974 9.03731ZM37 14L35.2001 7H33.2668C32.8666 7 32.4664 7.21557 32.3329 7.53846L29 14H31.3335L31.7993 12.9772H34.6665L34.9333 14H37ZM33.2865 9L34 12H32L33.2865 9Z"
        fill="#172B85"
      />
    </svg>
  );
}
